export const HOME = {
  root: "home-root",
  emergentLink: "home-emergent-link",
  title: "home-title",
  subtitle: "home-subtitle",
  loginLink: "home-login-link",
  themeToggle: "home-theme-toggle",
  apiStatus: "home-api-status",
};

export const LOGIN = {
  root: "login-root",
  title: "login-title",
  message: "login-message",
  backLink: "login-back-link",
};

export const NAV = {
  brand: "nav-brand",
  themeToggle: "nav-theme-toggle",
};

export const AUTH = {
  loginRoot: "login-root",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginError: "login-error",
  loginToSignup: "login-to-signup-link",
  // signup
  signupRoot: "signup-root",
  signupName: "signup-name-input",
  signupEmail: "signup-email-input",
  signupPassword: "signup-password-input",
  signupSubmit: "signup-submit-button",
  signupError: "signup-error",
  signupToLogin: "signup-to-login-link",
  // email verification (double opt-in)
  signupVerifyPanel: "signup-verify-panel",
  signupResend: "signup-resend-button",
  signupVerifyLink: "signup-verify-link",
  signupResendMsg: "signup-resend-message",
  verifyRoot: "verify-email-root",
  verifyError: "verify-email-error",
  verifyResendEmail: "verify-email-resend-email",
  verifyResend: "verify-email-resend-button",
  loginResend: "login-resend-verification-button",
  loginResendMsg: "login-resend-message",
  // magic link (Phase 9B)
  magicEmail: "magic-email-input",
  magicSubmit: "magic-submit-button",
  magicSent: "magic-sent-message",
  magicCallbackRoot: "magic-callback-root",
  magicCallbackError: "magic-callback-error",
  // onboarding (Phase 9B)
  onboardingRoot: "onboarding-root",
  onboardingSector: "onboarding-sector",
  onboardingLoadDemo: "onboarding-load-demo",
  onboardingConnectOwn: "onboarding-connect-own",
  onboardingSampleQuestion: "onboarding-sample-question",
  onboardingFinish: "onboarding-finish",
  onboardingSkip: "onboarding-skip",
  // dashboard
  dashboardRoot: "dashboard-root",
  dashboardWelcome: "dashboard-welcome",
  dashboardLogout: "dashboard-logout-button",
};

export const WORKSPACE = {
  navDashboard: "ws-nav-dashboard",
  navSchema: "ws-nav-schema",
  navGlossary: "ws-nav-glossary",
  navGraph: "ws-nav-graph",
  navTeam: "ws-nav-team",
  navChat: "ws-nav-chat",
  navAsk: "ws-nav-ask",
  navBoards: "ws-nav-boards",
  navPresent: "ws-nav-present",
  navReports: "ws-nav-reports",
  navAlerts: "ws-nav-alerts",
  navSignals: "ws-nav-signals",
  navSemantics: "ws-nav-semantics",
  navLogout: "ws-nav-logout",
  navMonitor: "ws-nav-monitor",
  navModel: "ws-nav-model",
  navAdmin: "ws-nav-admin",
  mobileMenu: "ws-mobile-menu",
  switcher: "ws-switcher",
  switcherItem: "ws-switcher-item",
  switcherFilter: "ws-switcher-filter",
  newWorkspace: "ws-new-workspace",
  cmdkTrigger: "ws-cmdk-trigger",
};

export const HEALTH = {
  root: "health-root",
  refresh: "health-refresh",
  cardMongo: "health-card-mongo",
  cardFaiss: "health-card-faiss",
  cardJob: "health-card-job",
  cardSchedule: "health-card-schedule",
  cardAlert: "health-card-alert",
  cardRazorpay: "health-card-razorpay",
  connectors: "health-connectors",
};

export const DOCS = {
  root: "docs-root",
  sidebar: "docs-sidebar",
  content: "docs-content",
  backToApp: "docs-back-to-app",
};

export const SIGNALS = {
  // queue
  queueRoot: "signals-queue-root",
  queueEmpty: "signals-queue-empty",
  statusFilter: "signals-status-filter",
  row: "signals-row",
  rowOpen: "signals-row-open",
  approveBtn: "signals-approve",
  rejectBtn: "signals-reject",
  silenceBtn: "signals-silence",
  // tabs
  tabQueue: "signals-tab-queue",
  tabRegistry: "signals-tab-registry",
  // evidence dialog
  dialog: "signals-evidence-dialog",
  commentInput: "signals-comment-input",
  commentSubmit: "signals-comment-submit",
  commentItem: "signals-comment-item",
  dialogApprove: "signals-dialog-approve",
  dialogReject: "signals-dialog-reject",
  dialogSilence: "signals-dialog-silence",
  // registry list
  registryRoot: "signals-registry-root",
  registryEmpty: "signals-registry-empty",
  registryRow: "signals-registry-row",
  exportCsv: "signals-export-csv",
  // registry entry
  entryRoot: "signals-registry-entry-root",
  exportPdf: "signals-export-pdf",
  // promote dialog (chat / alert)
  promoteDialog: "signals-promote-dialog",
  promoteName: "signals-promote-name",
  promoteSeverity: "signals-promote-severity",
  promoteSubmit: "signals-promote-submit",
};

export const REPORTS = {
  root: "reports-root",
  empty: "reports-empty-state",
  search: "reports-search-input",
  row: "reports-row",
  // save dialog (from chat)
  saveDialog: "report-save-dialog",
  saveName: "report-save-name",
  saveScheduleToggle: "report-save-schedule-toggle",
  saveSubmit: "report-save-submit",
  // schedule form
  cronPreset: "report-cron-preset",
  cronCustom: "report-cron-custom",
  tzSelect: "report-tz-select",
  deliverySelect: "report-delivery-select",
  recipients: "report-recipients-input",
  slackUrl: "report-slack-url-input",
  webhookUrl: "report-webhook-url-input",
  cronPreview: "report-cron-preview",
  // detail
  detailRoot: "report-detail-root",
  runNow: "report-run-now",
  deleteReport: "report-delete",
  addScheduleBtn: "report-add-schedule",
  scheduleRow: "report-schedule-row",
  deleteSchedule: "report-delete-schedule",
  pauseSchedule: "report-pause-schedule",
  runHistoryRow: "report-run-history-row",
};

export const ALERTS = {
  root: "alerts-root",
  empty: "alerts-empty-state",
  search: "alerts-search-input",
  row: "alerts-row",
  // watch dialog (from chat)
  watchDialog: "alert-watch-dialog",
  watchName: "alert-watch-name",
  watchMethod: "alert-watch-method",
  watchSubmit: "alert-watch-submit",
  // method config fields
  thresholdOp: "alert-threshold-op",
  thresholdValue: "alert-threshold-value",
  pctPeriod: "alert-pct-period",
  pctDrop: "alert-pct-drop",
  pctDirection: "alert-pct-direction",
  zWindow: "alert-z-window",
  zSensitivity: "alert-z-sensitivity",
  zDirection: "alert-z-direction",
  seasonSensitivity: "alert-season-sensitivity",
  seasonType: "alert-season-type",
  seasonDirection: "alert-season-direction",
  severityOverride: "alert-severity-override",
  cooldown: "alert-cooldown",
  // detail
  detailRoot: "alert-detail-root",
  testNow: "alert-test-now",
  pauseToggle: "alert-pause-toggle",
  editToggle: "alert-edit-toggle",
  editMethod: "alert-edit-method",
  editSave: "alert-edit-save",
  deleteAlert: "alert-delete",
  runRow: "alert-run-row",
  // bell
  bell: "alert-bell",
  bellBadge: "alert-bell-badge",
  bellItem: "alert-bell-item",
  bellClearAll: "alert-bell-clear-all",
  bellDismissItem: "alert-bell-dismiss-item",
};


export const CHAT = {
  root: "chat-root",
  newConversation: "chat-new-conversation",
  conversationItem: "chat-conversation-item",
  input: "chat-input",
  send: "chat-send-button",
  thread: "chat-thread",
  userMessage: "chat-user-message",
  assistantMessage: "chat-assistant-message",
  showPlan: "chat-show-plan",
  rerun: "chat-rerun",
  saveReport: "chat-save-report",
  watchMetric: "chat-watch-metric",
  promoteSignal: "chat-promote-signal",
  clarification: "chat-clarification",
  clarificationChip: "chat-clarification-chip",
  refusal: "chat-refusal",
  suggestion: "chat-suggestion",
  uploadFile: "chat-upload-file",
  sourcePicker: "chat-source-picker",
};

export const UPLOAD = {
  trigger: "upload-data-trigger",
  dialog: "upload-data-dialog",
  fileInput: "upload-file-input",
  dropzone: "upload-dropzone",
  destNew: "upload-dest-new",
  destCurrent: "upload-dest-current",
  datasetName: "upload-dataset-name",
  submit: "upload-submit",
  progress: "upload-progress",
};

export const BOARD = {
  // list
  root: "boards-root",
  newBtn: "boards-new-button",
  createInput: "boards-create-name",
  card: "board-card",
  empty: "boards-empty",
  // detail
  detailRoot: "board-detail-root",
  renameInput: "board-rename-input",
  shareBtn: "board-share-button",
  pdfBtn: "board-pdf-button",
  widget: "board-widget",
  widgetExplain: "board-widget-explain",
  widgetExplanation: "board-widget-explanation",
  widgetRemove: "board-widget-remove",
  detailEmpty: "board-detail-empty",
  // share dialog
  shareDialog: "board-share-dialog",
  shareToggle: "board-share-toggle",
  shareLink: "board-share-link",
  shareEmbed: "board-share-embed",
  copyLink: "board-copy-link",
  copyEmbed: "board-copy-embed",
  // add-to-dashboard (from chat)
  addDialog: "add-to-dashboard-dialog",
  addTrigger: "chat-add-to-dashboard",
  addPick: "add-dashboard-pick",
  addNewName: "add-dashboard-new-name",
  addSubmit: "add-dashboard-submit",
  // public
  publicRoot: "public-board-root",
};

export const DECK = {
  root: "decks-root",
  promptInput: "deck-prompt-input",
  generateBtn: "deck-generate-button",
  datasetPicker: "deck-dataset-picker",
  card: "deck-card",
  empty: "decks-empty",
  detailRoot: "deck-detail-root",
  generating: "deck-generating",
  slide: "deck-slide",
  summary: "deck-summary",
  downloadBtn: "deck-download-button",
  downloadPdf: "deck-download-pdf",
  downloadPptx: "deck-download-pptx",
  downloadHtml: "deck-download-html",
  shareBtn: "deck-share-button",
  shareDialog: "deck-share-dialog",
  shareToggle: "deck-share-toggle",
  shareLink: "deck-share-link",
  publicRoot: "public-deck-root",
  fromChat: "chat-generate-deck",
  composer: "chat-build-deck",
};

export const TEAM = {
  root: "team-root",
  addEmail: "team-add-email",
  addRole: "team-add-role",
  addSubmit: "team-add-submit",
  memberRow: "team-member-row",
  roleSelect: "team-role-select",
  removeBtn: "team-remove-button",
};

export const REL = {
  root: "rel-root",
  empty: "rel-empty",
  inferBtn: "rel-infer-button",
  graph: "rel-graph",
  row: "rel-row",
  rowToggle: "rel-row-toggle",
  rationale: "rel-rationale",
  confirmBtn: "rel-confirm-button",
  rejectBtn: "rel-reject-button",
  deleteBtn: "rel-delete-button",
  sourceSelect: "rel-source-select",
  addFrom: "rel-add-from",
  addFromCol: "rel-add-from-col",
  addTo: "rel-add-to",
  addToCol: "rel-add-to-col",
  addKind: "rel-add-kind",
  addSubmit: "rel-add-submit",
  // ER path explorer (Phase 10 P3)
  pathFrom: "rel-path-from",
  pathTo: "rel-path-to",
  pathFind: "rel-path-find",
  pathResult: "rel-path-result",
  pathHop: "rel-path-hop",
  pathNone: "rel-path-none",
  // focused graph (crowding fix)
  focusSelect: "rel-focus-select",
  focusClear: "rel-focus-clear",
  focusHint: "rel-focus-hint",
};

export const SEMANTICS = {
  // graph page
  root: "semantics-root",
  empty: "semantics-empty",
  graph: "semantics-graph",
  refresh: "semantics-refresh",
  discoverBtn: "semantics-discover-button",
  kindFilter: "semantics-kind-filter",
  legend: "semantics-legend",
  node: "semantics-node",
  // node panel
  nodePanel: "semantics-node-panel",
  nodePanelClose: "semantics-node-panel-close",
  nodeColumn: "semantics-node-column",
  // edge drawer
  edgeDrawer: "semantics-edge-drawer",
  edgeVerify: "semantics-edge-verify",
  edgeReject: "semantics-edge-reject",
  edgeEdit: "semantics-edge-edit",
  edgeEditSave: "semantics-edge-edit-save",
  edgeSampleRow: "semantics-edge-sample-row",
  // focused graph (crowding fix)
  focusInput: "semantics-focus-input",
  focusClear: "semantics-focus-clear",
  focusHint: "semantics-focus-hint",
  // metrics list
  metricsRoot: "semantics-metrics-root",
  metricsEmpty: "semantics-metrics-empty",
  metricsTab: "semantics-tab-metrics",
  graphTab: "semantics-tab-graph",
  metricsDomainFilter: "semantics-metrics-domain-filter",
  metricsStatusFilter: "semantics-metrics-status-filter",
  metricRow: "semantics-metric-row",
  metricPromote: "semantics-metric-promote",
  newMetricBtn: "semantics-new-metric-button",
  // metric dialog
  metricDialog: "semantics-metric-dialog",
  metricName: "semantics-metric-name",
  metricDefinition: "semantics-metric-definition",
  metricSql: "semantics-metric-sql",
  metricGrain: "semantics-metric-grain",
  metricDimensions: "semantics-metric-dimensions",
  metricSynonyms: "semantics-metric-synonyms",
  metricDomain: "semantics-metric-domain",
  metricStatus: "semantics-metric-status",
  metricSubmit: "semantics-metric-submit",
  // metric detail
  metricDetailRoot: "semantics-metric-detail-root",
  metricDelete: "semantics-metric-delete",
  metricDeleteConfirm: "semantics-metric-delete-confirm",
  metricEdit: "semantics-metric-edit",
  usageChat: "semantics-usage-chat",
  usageReports: "semantics-usage-reports",
  usageAlerts: "semantics-usage-alerts",
  // packs (Phase 10)
  packsTab: "semantics-tab-packs",
  packsRoot: "semantics-packs-root",
  packCard: "semantics-pack-card",
  packInstall: "semantics-pack-install",
  packView: "semantics-pack-view",
  packInstalledBadge: "semantics-pack-installed-badge",
  packDetailRoot: "semantics-pack-detail-root",
  packBack: "semantics-pack-back",
};

export const SETTINGS = {
  // shared
  tabWorkspace: "settings-tab-workspace",
  tabAudit: "settings-tab-audit",
  tabMembers: "settings-tab-members",
  tabBilling: "settings-tab-billing",
  navSettings: "ws-nav-settings",
  denied: "settings-denied",
  // workspace
  workspaceRoot: "settings-workspace-root",
  renameInput: "settings-rename-input",
  renameSave: "settings-rename-save",
  llmProvider: "settings-llm-provider",
  llmModel: "settings-llm-model",
  llmKey: "settings-llm-key",
  llmSave: "settings-llm-save",
  llmClearKey: "settings-llm-clear-key",
  llmSource: "settings-llm-source",
  deleteWorkspace: "settings-delete-workspace",
  deleteConfirm: "settings-delete-confirm",
  // developers / API keys (Phase 10b)
  apiKeysSection: "settings-api-keys-section",
  apiKeyNameInput: "settings-api-key-name",
  apiKeyGenerate: "settings-api-key-generate",
  apiKeyRow: "settings-api-key-row",
  apiKeyRevoke: "settings-api-key-revoke",
  apiKeyDialog: "settings-api-key-dialog",
  apiKeyValue: "settings-api-key-value",
  apiKeyCopy: "settings-api-key-copy",
  apiKeyDone: "settings-api-key-done",
  apiKeysEmpty: "settings-api-keys-empty",
  // audit
  auditRoot: "settings-audit-root",
  auditActorFilter: "settings-audit-actor-filter",
  auditKindFilter: "settings-audit-kind-filter",
  auditExport: "settings-audit-export",
  auditRow: "settings-audit-row",
  auditEmpty: "settings-audit-empty",
};

export const BILLING = {
  root: "billing-root",
  planBadge: "billing-plan-badge",
  startTrial: "billing-start-trial",
  trialBanner: "trial-banner",
  trialBannerUpgrade: "trial-banner-upgrade",
  togglePeriodMonthly: "billing-period-monthly",
  togglePeriodAnnual: "billing-period-annual",
  seatsInput: "billing-seats-input",
  upgradePro: "billing-upgrade-pro",
  upgradeBusiness: "billing-upgrade-business",
  cancelPlan: "billing-cancel-plan",
  usageChat: "billing-usage-chat",
  usageReports: "billing-usage-reports",
  usageConnectors: "billing-usage-connectors",
  quotaDialog: "chat-quota-dialog",
  quotaUpgrade: "chat-quota-upgrade",
};

export const SCHEMA = {
  root: "schema-root",
  empty: "schema-empty-state",
  seedButton: "schema-seed-button",
  jobProgress: "schema-job-progress",
  table: "schema-table-card",
  addDefinition: "schema-add-definition",
  pgButton: "schema-pg-button",
  pgName: "schema-pg-name",
  pgHost: "schema-pg-host",
  pgPort: "schema-pg-port",
  pgDatabase: "schema-pg-database",
  pgUser: "schema-pg-user",
  pgPassword: "schema-pg-password",
  pgSubmit: "schema-pg-submit",
  pgProgress: "schema-pg-progress",
  // connection progress drawer (Phase 10 P2)
  connDrawer: "schema-connection-drawer",
  connOverall: "schema-connection-overall",
  connStage: "schema-connection-stage", // suffix with `-${stage.key}`
  connDone: "schema-connection-done",
  // Postgres table filter (Phase 10b — 2-step connect)
  pgListTables: "schema-pg-list-tables",
  pgStep2: "schema-pg-step2",
  pgTableSearch: "schema-pg-table-search",
  pgTableRow: "schema-pg-table-row",
  pgTableCheckbox: "schema-pg-table-checkbox",
  pgSelectAll: "schema-pg-select-all",
  pgSelectedCount: "schema-pg-selected-count",
  pgConnectSelected: "schema-pg-connect-selected",
  pgBack: "schema-pg-back",
};

export const GLOSSARY = {
  root: "glossary-root",
  empty: "glossary-empty-state",
  generateButton: "glossary-generate-button",
  searchInput: "glossary-search-input",
  searchButton: "glossary-search-button",
  textFilter: "glossary-text-filter",
  kindFilter: "glossary-kind-filter",
  lifecycleFilter: "glossary-lifecycle-filter",
  sensitivityFilter: "glossary-sensitivity-filter",
  row: "glossary-row",
  rowCheckbox: "glossary-row-checkbox",
  bulkBar: "glossary-bulk-bar",
  bulkLifecycle: "glossary-bulk-lifecycle",
  bulkSensitivity: "glossary-bulk-sensitivity",
  bulkApply: "glossary-bulk-apply",
  drawer: "glossary-drawer",
  drawerDefinition: "glossary-drawer-definition",
  drawerLifecycle: "glossary-drawer-lifecycle",
  drawerSensitivity: "glossary-drawer-sensitivity",
  drawerSynonyms: "glossary-drawer-synonyms",
  drawerSave: "glossary-drawer-save",
  coverage: "glossary-coverage",
};

export const ASK_PREVIEW = {
  root: "ask-preview-root",
  input: "ask-preview-input",
  submit: "ask-preview-submit",
  example: "ask-preview-example",
  empty: "ask-preview-empty",
  result: "ask-preview-result",
  intent: "ask-preview-intent",
  understanding: "ask-preview-understanding",
  confidence: "ask-preview-confidence",
  tables: "ask-preview-tables",
  table: "ask-preview-table",
  columns: "ask-preview-columns",
  joinPath: "ask-preview-join-path",
  joinHop: "ask-preview-join-hop",
  sql: "ask-preview-sql",
  assumptions: "ask-preview-assumptions",
  clarification: "ask-preview-clarification",
  refusal: "ask-preview-refusal",
  runInChat: "ask-preview-run-in-chat",
  noSource: "ask-preview-no-source",
  saveMetric: "ask-preview-save-metric",
  error: "ask-preview-error",
};

export const EVIDENCE = {
  attachBtn: "evidence-attach-btn",
  showBtn: "evidence-show-btn",
  panel: "evidence-panel",
  panelClose: "evidence-panel-close",
  exportPdf: "evidence-export-pdf",
  exportJson: "evidence-export-json",
  answerId: "evidence-answer-id",
  question: "evidence-question",
  sql: "evidence-sql",
  explanation: "evidence-explanation",
  lineageTable: "evidence-lineage-table",
  rbacRole: "evidence-rbac-role",
  signature: "evidence-signature",
  graphVersion: "evidence-graph-version",
  shareBtn: "evidence-share-btn",
  shareDialog: "evidence-share-dialog",
  shareCreateBtn: "evidence-share-create-btn",
  shareUrl: "evidence-share-url",
  shareCopy: "evidence-share-copy",
  shareRevoke: "evidence-share-revoke",
  shareExpiry: "evidence-share-expiry-select",
  shareRow: "evidence-share-row",
};

export const SHARE_VIEW = {
  root: "share-view-root",
  loading: "share-view-loading",
  gone: "share-view-gone",
  revoked: "share-view-revoked",
  expired: "share-view-expired",
  exportPdf: "share-view-export-pdf",
  signatureBadge: "share-view-signature-badge",
  question: "share-view-question",
  sql: "share-view-sql",
  answerId: "share-view-answer-id",
};

export const CHECKS = {
  root: "checks-root",
  seedBtn: "checks-seed-btn",
  newCheckBtn: "checks-new-btn",
  newSetBtn: "checks-new-set-btn",
  setCard: "checks-set-card",
  row: "checks-row",
  runBtn: "checks-run-btn",
  runSetBtn: "checks-run-set-btn",
  duplicateBtn: "checks-duplicate-btn",
  editBtn: "checks-edit-btn",
  deleteBtn: "checks-delete-btn",
  dialog: "checks-dialog",
  dialogName: "checks-dialog-name",
  dialogDescription: "checks-dialog-description",
  dialogQuestion: "checks-dialog-question",
  dialogSql: "checks-dialog-sql",
  dialogCitation: "checks-dialog-citation",
  dialogSubmit: "checks-dialog-submit",
  runResult: "checks-run-result",
  finding: "checks-finding",
  findingEvidence: "checks-finding-evidence",
  navChecks: "ws-nav-checks",
  navSurvey: "ws-nav-survey",
  navGovernance: "ws-nav-governance",
};

export const SURVEY = {
  root: "survey-root",
  runNow: "survey-run-now",
  scheduleBtn: "survey-schedule-btn",
  packetBtn: "survey-packet-btn",
  readinessPct: "survey-readiness-pct",
  facilityRow: "survey-facility-row",
  citationRow: "survey-citation-row",
  findingRow: "survey-finding-row",
  trendChart: "survey-trend-chart",
  setSelect: "survey-set-select",
};


